import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";
import ProductCard from "../components/ProductCard";
import WordReveal from "../components/WordReveal";
import NotFound from "./NotFound";

export default function CollectionPage() {
  const { slug } = useParams();
  const [collection, setCollection] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setCollection(null);
    setMissing(false);
    api.collection(slug).then(setCollection).catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <NotFound />;
  if (!collection) {
    return (
      <div className="mx-auto max-w-[1500px] px-4 sm:px-8 py-20 animate-pulse text-center">
        <div className="h-16 bg-cream w-1/3 mx-auto rounded-full" />
        <div className="mt-4 h-4 bg-cream w-1/2 mx-auto rounded-full" />
      </div>
    );
  }

  return (
    <div data-testid="collection-page" className="pb-28">
      <SEO
        title={collection.seo_title || `${collection.name} — S H & SONS ®`}
        description={collection.seo_description || collection.description}
        image={collection.image}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: `${collection.name} — S H & SONS ®`,
          description: collection.seo_description || collection.description,
        }}
      />
      <div className="pt-8 sm:pt-12 pb-6 text-center px-4">
        <nav className="text-[10px] uppercase tracking-[0.25em] text-mocha mb-6">
          <Link to="/" className="hover:text-ink">Home</Link> / <Link to="/shop" className="hover:text-ink">Catalogue</Link> / <span className="text-ink">{collection.name}</span>
        </nav>
        <WordReveal key={slug} as="h1" text={collection.name} data-testid="collection-title" className="h-display text-[clamp(2rem,9vw,3.75rem)] sm:text-7xl lg:text-[112px]" />
        <p className="mt-6 text-[13px] sm:text-[14px] text-charcoal/80 max-w-md mx-auto leading-relaxed">{collection.description}</p>
        <p className="mt-4 text-[12px] text-mocha" data-testid="collection-product-count">{collection.products.length} pieces</p>
      </div>

      <div className="mx-auto max-w-[1500px] px-4 sm:px-8 mt-10">
        {collection.products.length === 0 ? (
          <p className="py-20 text-center text-2xl font-light text-charcoal">Pieces arriving soon.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14" data-testid="collection-product-grid">
            {collection.products.map((p, i) => (
              <ProductCard key={p.slug} product={p} index={i} />
            ))}
          </div>
        )}
      </div>

      <div className="mt-20 text-center">
        <Link to="/shop" data-testid="collection-shop-all" className="pill-dark px-8">Explore all designs</Link>
      </div>
    </div>
  );
}
